<template>
  <nav class="menu">
    <ul class="menu-list">
      <navigation-menu-item v-for="item in menu" :value="item"></navigation-menu-item>
    </ul>
  </nav>
</template>

<script>
  import NavigationMenuItem from "./NavigationMenuItem";

  export default {
    vuex: {
      getters: { menu: state => state.menu }
    },
    components: { NavigationMenuItem }
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';
  @import '../../assets/scss/devices.scss';
  
  .menu{
    position: absolute;
    top: 0;
    left: 150px;
    right: 245px;
    height: 71px;

    @include min-screen(1200px){
      right: 295px;
    }

    text-align: center;
    background: #fff;

    .transparent &{
      background: transparent;
    }
  }

  .menu-list{
    @include clear-fix;
    display: inline-block;
    list-style: none;
    margin: 0px auto;
    max-width: 1100px;
    width: 100%;
    height: 70px;
    padding: 0;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// NavigationMenu.vue?e1f08d4e